module.exports = __webpack_public_path__ + "img/login-theme1.676d03bb.svg";